import { render } from "./BatchRemarkInput.vue?vue&type=template&id=15a6daa1&scoped=true"
import script from "./BatchRemarkInput.vue?vue&type=script&lang=js"
export * from "./BatchRemarkInput.vue?vue&type=script&lang=js"

import "./BatchRemarkInput.vue?vue&type=style&index=0&id=15a6daa1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a6daa1"]])

export default __exports__